import { BulkExportServiceOld } from "./services/BulkExportService";

const apiUrl = process.env.REACT_APP_API_URL;
export const bulkExportService = new BulkExportServiceOld({
  baseUrl: apiUrl,
});

// TODO: Можно вынести и в верхний DI, но тут он тоже нужен, обсудим
